import React from 'react';
import { Alert, AlertTitle, Fade, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import styled from '@emotion/styled';

const NotificationAlert = ({ type, message, onClose, title }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon fontSize="inherit" />;
      case 'error':
        return <CancelIcon fontSize="inherit" />;
      default:
        return <InfoIcon fontSize="inherit" />;
    }
  };

  const getStyles = () => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: 'rgba(46, 125, 50, 0.08)',
          color: '#1e4620',
          borderColor: 'rgba(46, 125, 50, 0.2)'
        };
      case 'error':
        return {
          backgroundColor: 'rgba(211, 47, 47, 0.08)',
          color: '#ab1f1f',
          borderColor: 'rgba(211, 47, 47, 0.2)'
        };
      default:
        return {
          backgroundColor: 'rgba(21, 101, 192, 0.08)',
          color: '#0d47a1',
          borderColor: 'rgba(21, 101, 192, 0.2)'
        };
    }
  };

  const styles = getStyles();

  return (
    <NotificationWrapper>
      <Fade in={!!message}>
        <StyledAlert
          severity={type}
          onClose={onClose}
          icon={getIcon()}
          sx={{
            ...styles,
            direction: 'rtl'
          }}
        >
          {title && (
            <AlertTitle sx={{ 
              fontWeight: 600,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              mb: 0.5
            }}>
              {title}
            </AlertTitle>
          )}
          <AlertMessage>{message}</AlertMessage>
        </StyledAlert>
      </Fade>
    </NotificationWrapper>
  );
};

const NotificationWrapper = styled(Box)`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 8px 16px;
  
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const StyledAlert = styled(Alert)`
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  padding: 12px 16px;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .MuiAlert-icon {
    font-size: 24px;
    padding: 2px;
    margin-left: 12px;
    margin-right: 0;
    opacity: 0.9;
  }
  
  .MuiAlert-message {
    padding: 4px 0;
    text-align: right;
  }
  
  .MuiAlert-action {
    padding-top: 0;
    margin-right: auto;
    margin-left: -8px;
  }

  @media (max-width: 600px) {
    padding: 10px 12px;
    border-radius: 10px;
    
    .MuiAlert-icon {
      font-size: 20px;
      margin-left: 8px;
    }
    
    .MuiAlert-action {
      padding-right: 0;
    }
  }
`;

const AlertMessage = styled.div`
  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: 400;
  
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

export default NotificationAlert; 